import { TextInput } from "react-admin";
import React from "react";

export const UserFilter = [
  <TextInput
    key="email"
    source="email"
    color="secondary"
    variant="filled"
    margin="normal"
    resettable
    alwaysOn
  />,
  <TextInput
    key="ids"
    source="ids"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Ids separated by comma"
    resettable
    alwaysOn
  />,
];

export const UserFilterForMB = [
  ...UserFilter,
  <TextInput
    key="name"
    source="name"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Name"
    resettable
    alwaysOn
  />,
  <TextInput
    key="surname"
    source="surname"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Surname"
    resettable
    alwaysOn
  />,
  <TextInput
    key="platform"
    source="platform"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Platform"
    resettable
    alwaysOn
  />,
  <TextInput
    key="country"
    source="country"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Country"
    resettable
    alwaysOn
  />,
  <TextInput
    key="client_version"
    source="client_version"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Client varsion"
    resettable
    alwaysOn
  />,
];

export const UserFilterForYG = [
  ...UserFilter,
  <TextInput
    key="public_id"
    source="public_id"
    color="secondary"
    variant="filled"
    margin="normal"
    resettable
    alwaysOn
  />,
  <TextInput
    key="first_name"
    source="first_name"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Name"
    resettable
    alwaysOn
  />,
  <TextInput
    key="last_name"
    source="last_name"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Surname"
    resettable
    alwaysOn
  />,
];

export const UserFilterForWF = [
  ...UserFilter,
  <TextInput
    key="name"
    source="name"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Name"
    resettable
    alwaysOn
  />,
  <TextInput
    key="platform"
    source="platform"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Platform"
    resettable
    alwaysOn
  />,
  <TextInput
    key="client_version"
    source="client_version"
    color="secondary"
    variant="filled"
    margin="normal"
    placeholder="Client varsion"
    resettable
    alwaysOn
  />,
];
